const investment_url="https://investment-tracker.tashu.qzz.io/api";
// const investment_url="https://investmentservices-production.up.railway.app/api";
// const investment_url="https://investment-service-production.up.railway.app/api/users";
// const investment_url="http://localhost:8085/api/users";
// const investment_url="http://localhost:8088/api";


export default investment_url;